// src/components/watchDetail/RaceHeader/RaceHeader.js
import React, { useState, useCallback } from "react";
import PropTypes from "prop-types";
import { Star, Share2, BarChart2, AlertTriangle } from "lucide-react";
import "./RaceHeader.css";

const RaceHeader = ({
  race,
  onShare,
  onToggleFavorite,
  isFavorite,
  onToggleStats,
  showStats,
}) => {
  const [showTooltip, setShowTooltip] = useState(false);
  const [error, setError] = useState(null);

  const handleShare = useCallback(
    async (e) => {
      e.preventDefault();
      e.stopPropagation();

      try {
        await onShare();
      } catch (err) {
        setError(err.message);
        setShowTooltip(true);
        setTimeout(() => {
          setShowTooltip(false);
          setError(null);
        }, 2000);
      }
    },
    [onShare]
  );

  if (!race) {
    return (
      <div className="race-header error">
        <AlertTriangle size={24} />
        <p>Race data unavailable</p>
      </div>
    );
  }

  return (
    <div className="race-headerD">
      <div className="race-header-purple-circle"></div>
      <div className="header-contentD z-10">
        <div className="title-sectionD">
          <div className="title-statusD">
            <div className="live-indicatorD">
              <span className="live-dotD"></span>
              <span className="live-textD">Live</span>
            </div>
            <h1 className="race-titleD">{race.title}</h1>
          </div>
          <div className="race-typeD">
            {race.type && <span className="race-type-textD z-10">{race.type}</span>}
            {race.handicap && (
              <span className="handicap-textD z-10">{race.handicap}</span>
            )}
          </div>
        </div>
        <div className="header-actionsD flex-col flex">
          <div className="flex justify-end gap-1">
            <button
              className={`action-buttonD stats-buttonD p-2 ${showStats ? "activeD" : ""
                }`}
              onClick={onToggleStats}
              aria-label="Toggle statistics"
            >
              <BarChart2 size={20} />
            </button>
            <button
              className="action-buttonD p-2 share-buttonD"
              onClick={handleShare}
              aria-label="Share race"
            >
              <Share2 size={20} />
              {showTooltip && (
                <div className="share-tooltipD">{error || "Share this race"}</div>
              )}
            </button>
            <button
              className={`action-buttonD p-2 favorite-buttonD ${isFavorite ? "activeD" : ""
                }`}
              onClick={onToggleFavorite}
              aria-label={
                isFavorite ? "Remove from favorites" : "Add to favorites"
              }
            >
              <Star className={isFavorite ? "filledD" : ""} size={20} />
            </button>
          </div>
          <div className="race-infoD flex gap-32">
            <div className="prize-poolD">
              <span className="prize-pool-labelD">Total Prize Pool</span>
              <span className="amountD text-right">
                ${race.totalPrizePool?.toLocaleString()}
              </span>
            </div>
            {race.totalVolume && (
              <div className="volume-infoD">
                <span className="volume-labelD">Total Volume</span>
                <span className="volume-amountD text-right">
                  ${race.totalVolume.toLocaleString()}
                </span>
              </div>
            )}
          </div>
        </div>
      </div>

    </div>
  );
};

RaceHeader.propTypes = {
  race: PropTypes.shape({
    title: PropTypes.string.isRequired,
    type: PropTypes.string,
    handicap: PropTypes.string,
    totalPrizePool: PropTypes.number,
    totalVolume: PropTypes.number,
  }),
  onShare: PropTypes.func.isRequired,
  onToggleFavorite: PropTypes.func.isRequired,
  isFavorite: PropTypes.bool.isRequired,
  onToggleStats: PropTypes.func.isRequired,
  showStats: PropTypes.bool.isRequired,
};

RaceHeader.defaultProps = {
  isFavorite: false,
  showStats: false,
};

export default RaceHeader;
